import { useState } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { httpBatchLink } from "@trpc/client";
import { RouterProvider } from "react-router-dom";
import { trpc } from "./lib/trpc";
import { queryClient } from "./lib/queryClient";
import { router } from "./router";
import { DrawerStackProvider } from "./components/Drawer";

export function App() {
  const [trpcClient] = useState(() =>
    trpc.createClient({
      links: [
        httpBatchLink({
          url: "/trpc",
          /**
           * PARTİ SINIRLARI — bu hata CANLIDA ZATEN YAŞANDI.
           *
           * httpBatchLink varsayılanda `maxItems: Infinity` ve `maxURLLength: Infinity`
           * kullanır; tüm yordam adlarını TEK bir `/trpc/a,b,c,…` URL parçasına birleştirir.
           * Fastify'ın `maxParamLength` varsayılanı (100) bunu 404'e çeviriyordu ve sunucu
           * tarafında 5000'e çıkarılarak yamandı (apps/api/src/index.ts). Yama sınırı
           * ötelemekten ibaret: Apache'nin `LimitRequestLine` sınırı (8190) hâlâ duruyor
           * ve çoklu sekmede aynı anda mount olan sayfa sayısıyla parti boyu doğrusal büyür.
           *
           * Sınırı İSTEMCİDE koymak doğru yer: aşan istekler sessizce 404 olmak yerine
           * ikinci bir partiye bölünür. 4000, sunucudaki 5000'in altında güvenlik payı bırakır.
           */
          maxItems: 15,
          maxURLLength: 4000,
          // Çok-tesisli: seçili tesis header'ı (yalnız süper-admin'i etkiler; normal kullanıcı sunucuda kendi tesisine sabit).
          headers: () => {
            const fid = localStorage.getItem("steperp.activeFacility");
            return fid ? { "x-facility-id": fid } : {};
          },
          fetch: (url, opts) => fetch(url, { ...opts, credentials: "include" }),
        }),
      ],
    })
  );

  return (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        <DrawerStackProvider>
          <RouterProvider router={router} />
        </DrawerStackProvider>
      </QueryClientProvider>
    </trpc.Provider>
  );
}
